import ResetDataStatus from './ResetDataStatus';

export default ResetDataStatus;
